import { FC } from 'react';
import { Link, Stack, Typography } from '@mui/material';
import { GridNoRowsOverlay, NoRowsOverlayPropsOverrides } from '@mui/x-data-grid';
import { NoResultsIcon } from '~/icons';
import { useTableFilters } from './context';

const TableNoRows: FC<NoRowsOverlayPropsOverrides> = () => {
  const { appliedFilters, openFilters, clearFilters } = useTableFilters();

  if (Object.values(appliedFilters).flat().length === 0) {
    return <GridNoRowsOverlay />;
  }

  return (
    <Stack alignItems="center" justifyContent="center" spacing={1} height="100%">
      <NoResultsIcon style={{ width: '100px', height: '100px' }} />
      <Typography variant="h6">
        No matching Filtered results. Try{' '}
        <Link
          color="electricBlue.main"
          sx={{ cursor: 'pointer', textDecoration: 'none' }}
          onClick={() => openFilters()}
        >
          modifying
        </Link>{' '}
        or{' '}
        <Link color="electricBlue.main" sx={{ cursor: 'pointer', textDecoration: 'none' }} onClick={clearFilters}>
          cleaning
        </Link>{' '}
        your filter.
      </Typography>
    </Stack>
  );
};

export default TableNoRows;
